import { decrypt } from "../helpers/decrypt";
import { getUserLS } from "../helpers/LocalStorageIMJ";

export const validateRol = () => {
    const dataUser = decrypt(getUserLS());
    const rolesAdmitidos = ['Administrador'];

    const rolName = dataUser?.role?.name;
    return rolesAdmitidos.includes(rolName);
}

export const isAdmin = () => {
    const dataUser = decrypt(getUserLS());
    const rolesAdmin = "Administrador";
    const rolName = dataUser?.role?.name;
    return rolesAdmin === rolName;
}

export const validatePersonalCreate = () => {
    const dataUser = decrypt(getUserLS());
    const puedoReservar = dataUser?.personal?.puedoReservar;
    return puedoReservar;
}
export const validatePersonal = (id: number | undefined) => {
    const dataUser = decrypt(getUserLS());
    if (!id) return false;
    const puedoReservar = dataUser?.personal?.puedoReservar;
    return puedoReservar && dataUser?.id === id;
}

export const validateReservacionPor = (id: number | undefined) => {
    const dataUser = decrypt(getUserLS());
    if (!id) return false;
    return dataUser?.id === id;
}